import { Injector, ModuleWithProviders, NgModule, Type } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AUTHENTICATED_HTTP_CLIENT } from './constants';
import { createAuthenticatedHttpClient } from './factories';
import { CommentService, IdGenerator, OperationTrackerService, ThreadService, UserFacadeService } from './services';
import {
  AbstractConfigurationProvider,
  AbstractTokenProvider,
  AuthenticationHttpHandlerService,
  CommentApiService,
  ThreadApiService,
} from './services/api';
import { effects } from './store/effects';
import { reducers, featureKey } from './store';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AnecdotesCommentInputComponent } from './components/comment-input/comment-input.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';

@NgModule({
  declarations: [AnecdotesCommentInputComponent],
  exports: [AnecdotesCommentInputComponent],
  imports: [CommonModule, FormsModule, OverlayModule, PortalModule],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class AnecdotesCommentingModule {
  static forRoot(
    configurationProviderType: Type<AbstractConfigurationProvider>,
    tokenProviderType: Type<AbstractTokenProvider>,
  ): ModuleWithProviders<AnecdotesCommentingModule> {
    return {
      ngModule: AnecdotesCommentingModule,
      providers: [
        ThreadApiService,
        CommentApiService,
        ThreadService,
        CommentService,
        UserFacadeService,
        OperationTrackerService,
        IdGenerator,
        ...StoreModule.forFeature(featureKey, reducers).providers,
        ...EffectsModule.forFeature(effects).providers,
        {
          provide: AbstractConfigurationProvider,
          useClass: configurationProviderType,
        },
        { provide: AbstractTokenProvider, useClass: tokenProviderType },
        AuthenticationHttpHandlerService,
        {
          provide: AUTHENTICATED_HTTP_CLIENT,
          useFactory: createAuthenticatedHttpClient,
          deps: [Injector],
        },
      ],
    };
  }
}
